import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {CreateServicioForm} from './components/CreateServicioForm'
import {Servicio} from './core/models'
import {fetchWithAuth} from '../../core/utils/fetchWithAuth'

const CreateServicioPage: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  // Función para obtener el token del localStorage
  const getToken = (): string | null => {
    return localStorage.getItem('X-TOKEN')
  }

  const handleSubmit = async (servicioData: Omit<Servicio, 'id'>) => {
    try {
      setLoading(true)
      setError(null)
      
      const token = getToken()
      if (!token) {
        throw new Error('No se encontró el token de autenticación')
      }

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-TOKEN': token
        },
        body: JSON.stringify({
          service: 'createConcepto',
          nombre: servicioData.nombre,
          valor: servicioData.valor,
          descripcion: servicioData.descripcion,
          variable: servicioData.variable ? 1 : 0,
          recurrente: servicioData.recurrente ? 1 : 0,
          estado: servicioData.estado ? 1 : 0,
          exonerado: servicioData.exonerado ? 1 : 0,
          enviar_facturacion_electronica: servicioData.enviar_facturacion_electronica ? 1 : 0,
          codigo_contable: servicioData.codigo_contable || '',
        })
      })

      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.status}`)
      }

      const data = await response.json()
      
      if (data.code === 'OK') {
        // Servicio creado exitosamente, redirigir a la lista
        navigate('/servicios')
      } else if (data.code === 'ERROR' && data.returned_message && data.returned_message.includes('JWT expired')) {
        // Token expirado, redirigir al login
        localStorage.removeItem('X-TOKEN')
        navigate('/auth/login')
        return
      } else {
        throw new Error(data.returned_message || 'Error al crear el servicio')
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <PageTitle>Crear Nuevo Servicio</PageTitle>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          <div className='card'>
            <div className='card-body'>
              {error && (
                <div className='alert alert-danger' role='alert'>
                  {error}
                </div>
              )}
              
              <CreateServicioForm 
                onSubmit={handleSubmit} 
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateServicioPage
